// we don't do any error checking on props, we assume the caller has done that already
// color (string), width (number of pixels), and height (number of pixels) should always be specified
const Icon = (props) => (
	<>
		<svg
			width={props.width}
			height={props.height}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<text
				x="12"
				y="18"
				textAnchor="middle"
				fontSize="20"
				fontWeight="bold"
				fill={props.color}
				fontFamily="Inter, sans-serif"
			>
				1:1
			</text>
		</svg>
	</>
);

export default Icon;
